import { Layers } from 'lucide-react';
import { Icon } from '../ui/Icon';
import { COLOR_BY_LABEL, type ColorBy } from './paint';
import { defineMessages } from '../../i18n/define';
import { useT } from '../../i18n/hooks';

const m = defineMessages({
  title: {
    id: 'map.layers.title',
    defaultMessage: 'Слой',
    description: 'Заголовок панели переключателей слоёв раскраски на карте; коротко',
  },
  group: {
    id: 'map.layers.group',
    defaultMessage: 'Слой раскраски',
    description: 'aria-label группы переключателей слоёв раскраски карты',
  },
  off: {
    id: 'map.layers.off',
    defaultMessage: 'на этом экране нет данных для слоя',
    description: 'Всплывающая подсказка отключённого слоя на карте: для него на этом экране нет данных',
  },
});


/** Набор по умолчанию; страница может предложить свой (`options`). */
export const DEFAULT_LAYER_OPTIONS: ColorBy[] = ['crop', 'workStatus', 'quarantine', 'landCategory', 'geometryStatus'];

export interface LayersPanelProps {
  value: ColorBy;
  onChange: (next: ColorBy) => void;
  /** Значения, которым на этом экране нечем питаться. */
  disabled?: ColorBy[];
  /** Какие слои предложить; по умолчанию — `DEFAULT_LAYER_OPTIONS`. */
  options?: ColorBy[];
  /** Подпись произвольного слоя (`values`) — её задаёт страница. */
  valuesTitle?: string;
}

/** Слои-переключатели: один активный слой раскраски за раз. */
export function LayersPanel({
  value,
  onChange,
  disabled = [],
  options = DEFAULT_LAYER_OPTIONS,
  valuesTitle,
}: LayersPanelProps) {
  const t = useT();
  return (
    <div className="layerspanel">
      <div className="layerspanel__title">
        <Icon icon={Layers} size={16} />
        {t(m.title)}
      </div>
      <div className="layerspanel__list" role="radiogroup" aria-label={t(m.group)}>
        {options.map((key) => {
          const off = disabled.includes(key);
          return (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={value === key}
              disabled={off}
              title={off ? t(m.off) : undefined}
              className={`layerspanel__btn focus-ring ${value === key ? 'is-on' : ''}`}
              onClick={() => onChange(key)}
            >
              {key === 'values' && valuesTitle ? valuesTitle : COLOR_BY_LABEL[key]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
